export default __webpack_public_path__ + "static/media/vendor.2c943e0f.png";